import { DEFAULT_STATE } from '../constants'

export const initialKeywordState = {
  keyword: DEFAULT_STATE.keyword,
  keywordTerms: DEFAULT_STATE.keywordTerms,
  // A clear usually writes the same '' the store already holds, which does not rerender a
  // `state.keyword` subscriber - so the input would keep showing text that is no longer applied.
  // Every clear bumps this counter instead, giving the input a value that always changes.
  keywordClearCount: DEFAULT_STATE.keywordClearCount,
}
